module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n<div id=\"ai-chat-modal\" title=\"AI ChatBot\" style=\"display: none;\">\r\n    <div class=\"ai-chat\">\r\n\r\n    </div>\r\n    <div class=\"ai-file-chip-area\"></div>\r\n    <div class=\"input-group search-area\" style=\"display:none;\">\r\n        <label class=\"control-label sr-only\">search</label>\r\n        <textarea id=\"userInput\" class=\"ai-form-control\" placeholder=\"Type your question here...\" rows=\"1\"></textarea>\r\n        <div class=\"input-toolbar\">\r\n            <div title=\"Attach file (.yaml, .yml, .json, .xml, .wsdl)\" class=\"toolbar-btn glyphicon glyphicon-paperclip attach-icon\"></div>\r\n            <div title=\"Send\" class=\"toolbar-btn glyphicon glyphicon-send send-icon\"></div>\r\n        </div>\r\n        <input type=\"file\" id=\"aiFileInput\" accept=\".yaml,.yml,.json,.xml,.wsdl\" style=\"display:none;\" />\r\n    </div>\r\n    <div id=\"messageCounter\" style=\"display:none;\">\r\n        You currently have <span id=\"messagesRemaining\"></span> out of <span id=\"messageLimit\"></span> messages remaining. <br/>\r\n        Should you require additional messages, please reach out to our <a href=\"https://www.perfectapps.com/resources/\">sales team</a> for further assistance.\r\n\r\n    </div>\r\n\r\n\r\n</div>\r\n")
  }
  return __output;

}